import { fetchLoLChampions } from "./leagueoflegends.apis"

const state = {
  champions: null,
}

const mutations = {
  UPDATE_CHAMPIONS: (state, champions) => {
    state.champions = champions
  },
}

const actions = {
  async loadChampions ({ state, commit }) {
    if (state.champions !== null) {
      return
    }
    const champions = await fetchLoLChampions()
    commit("UPDATE_CHAMPIONS", champions)
  },
}

const getters = {
  getChampions: state => state.champions || {},
  getChampionByName: state => championName => {
    return Object.values(state.champions || {})
      .find(({ name }) => name === championName)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/game/leagueoflegends/leagueoflegends.module.js